// import useAuth from "../../hooks/useAuth";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import useStore from "../../Hooks/useStore";
const RequireSignIn = ({ path }) => {
  const { auth } = useStore();
  const location = useLocation();
  //   console.log(auth, "auth");
  return auth?.email ? (
    <Outlet />
  ) : auth?.email ? (
    <Navigate to={"/notauthorized"} state={{ from: location }} replace />
  ) : (
    <Navigate to={"/signin"} state={{ from: location }} replace />
  );
};
export default RequireSignIn;
